const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc`, `bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc`, 1, 39), undefined, true, false, 1));
            }

            getTemplateName() {
                return `bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc`;
            }

            getSourceContext() {
                return new this.Source(``, `bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc`, ``);
            }
        }],
        [39, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/cloud-cover/cloud-cover.twig`, `bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc`, 1);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/cloud-cover/cloud-cover.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -2], [`content`, `Our Team`]]), false, false, 3));
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>
      We are a small, versatile team who care passionately about the web.
      We’re full of what our industry considers unicorns. Our designers
      code. Our developers went to art school.
    </p>
  `);
            }

            getTemplateName() {
                return `bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc');

let template = env.loadTemplate('bded9a1faec632f90d2c8c1f149411dc006b51fbef03a0553ed54923514f47fc');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/cloud-cover/demo/content.twig", args: context }
     );
     return rendered;;
};